<template>
    <div class="reviews">
        <div class="reviews-header">
            <div class="reviews-header__block">
                <h2 class="reviews-title">
                    {{ translates.reviews }}
                </h2>
                <span class="reviews-counter">{{ repliesCount }}</span>
            </div>
            <ABtn
                v-if="$mqAbove('MOBILE')"
                :label="translates.addComment"
                @click="openModal"
                class="dark outlined"
            />
        </div>
        <div class="reviews-items" v-if="repliesCount">
            <ReviewsItem
                v-for="reply in replyList"
                :key="reply.id"
                :result="reply"
                @replyTo="openModal(reply.id)"
            />
            <button
                class="reviews-button"
                v-if="replies.PAGE_NAV.countPage > replies.PAGE_NAV.currentPage"
                @click="loadMore"
            >
                {{ translates.showMore }}
            </button>
        </div>

        <ReviewsModal
            v-model="replyText"
            @onSubmit="addComment"
            ref="commentModal"
        />
    </div>
</template>

<script>
import {inject, computed, ref} from "vue";
import {send} from "../../../services/api";
import {ABtn} from "../../ui";
import {useAModal} from "../../ui";
import ReviewsModal from "../ReviewsModal/ReviewsModal";
import ReviewsItem from "./ReviewsItem/ReviewsItem";

export default {
    name: 'Reviews',
    props: {
        replies: Object,
        article: Object
    },
    components: {
        ReviewsItem,
        ReviewsModal,
        ABtn,
    },
    setup(props) {
        const translates = inject('translates', {})

        const modal = useAModal();

        const replyText = ref('');
        const replyList = ref(props.replies.list || []);
        const commentModal = ref(null);
        const replyToState = ref(false);
        const replyToId = ref(0);

        const openModal = (id) => {
            setReplyState(false)

            if (!isNaN(parseInt(id))) {
                setReplyState(id)
            }

            modal.show('reviews-modal');
        }

        const setReplyState = (id) => {
            replyText.value = ''

            if (id > 0) {
                replyToState.value = true
                replyToId.value = id

                return false;
            }

            replyToState.value = false
            replyToId.value = 0
        }

        const loadMore = async () => {
            await send(props.replies.PAGE_NAV.showMore, {method: 'get'}).then(response => {
                const repliesListResponse = response.BlogPageContainer?.data?.replies?.list || []
                replyList.value = replyList.value.concat(repliesListResponse)
                props.replies.PAGE_NAV.currentPage += 1
            })
        }

        const addComment = async () => {
            await send(
                props.article.params.link,
                {
                    method: 'post',
                },
                {
                    action: props.article.params.data.action,
                    sessid: props.article.params.data.sessid,
                    articleId: props.article.id,
                    commentId: replyToId.value || null,
                    text: replyText.value,
                }
            ).then((response) => {
                if (response.success) {
                    showNotification("success", "", response.success);
                    commentModal.value.closeModal()
                } else if (response.error) {
                    showNotification("warning", "", response.error);
                }
            });
        }

        const repliesCount = computed(() => {
          if(props?.replies?.list) {
            return Object.keys(props.replies.list).length
          } else return 0;

        })

        return {
            translates,
            openModal,
            repliesCount,
            replyText,
            addComment,
            commentModal,
            replyToId,
            replyList,
            loadMore
        }
    }
}
</script>

<style lang="scss" scoped>
.reviews {
    margin-bottom: 158px;
    @include tablet {
        margin-bottom: 62px;
    }
    @include mobile {
        margin-bottom: 60px;
    }
}

.reviews-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;

    &__block {
        display: flex;
        align-items: flex-end;
    }
}

.reviews-title {
    margin: 0;
}

.reviews-counter {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    padding: 3px 13px;
    background: #E9EBED;
    border-radius: 6px;
    margin-left: 15px;
}

.reviews-items {
    display: grid;
    grid-row-gap: 29px;
}

.reviews-button {
    background-color: transparent;
    border: 1px solid #D8DCDE;
    border-radius: 6px;
    height: 50px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
}
</style>